
export class ManualPayment {
  public InvoiceId: number;
  public InvoiceNumber: string;
	public PaymentType: number;
  public PaymentMethod: number;
  public Amount: number;
  public PaymentDate: Date;
  public TransactionReference: string;
  public PrivateNotes: string;
  public ConvertCCy: boolean;
  public EmailReceiptToClient: boolean;
  public CCY: string;
  public CreatedBy: number;
  public CustomerId: number;
  public CustomerName: string;
  public CustomerAddress: string;
  public CustomerEmail: string;
  public BusinessName: string;
  public BusinessLogo: string;
  public BusinessAddress: string;
  public LocationId: number;

  public ManualPayment() {
    this.ConvertCCy = false;
    this.EmailReceiptToClient = true;
    this.Amount = 0;
    this.PaymentDate = new Date();
  }

}

